export const SALES_REPORT_DOWNLOAD_PROGRESS_MAX = 100
